import useRequest, {
    RequestKeys,
    RequestFn,
} from 'app/hooks/useRequest'
import {
    RegionFirstLevel,
    TemperatureRange,
} from 'app/enums/label.enums'

import requests from 'app/requests/Account.requests'

const useGetAccountOptions = (id) => {
    return useRequest<{
        originRegion: RegionFirstLevel[],
        destinationRegion: RegionFirstLevel[],
        tempRange: TemperatureRange[]
    }>({
        key: RequestKeys.getAccountOptions,
        params: {
            accountId: id,
        },
        requestFunc: RequestFn.getEntity(requests.getRegionalGroupsByAccount),
        keepPreviousData: true,
        enabled: Boolean(id),
    })
}

export default useGetAccountOptions
